import { MAP_FIT_MAX_ZOOM } from "../map-config";

/** Ported from the old EstaidMap — Denmark-wide floor for the kortlag map. */
export const KORTLAG_MAP_MIN_ZOOM = 6;

/** Used when only a centroid is known. Same 30m-scale zoom as automatic fits. */
export const KORTLAG_MAP_CENTROID_ZOOM = MAP_FIT_MAX_ZOOM;

export const KORTLAG_MAP_FALLBACK_ZOOM = 10;

/** Tilt applied when 3D view is turned on. Fill-extrusion is invisible at pitch 0. */
export const KORTLAG_3D_PITCH = 60;

/** Hosted style layer. Shown while 3D is on, even if the buildings kortlag is off. */
export const KORTLAG_BUILDING_EXTRUSION_LAYER_ID = "building-extrusion";

/** Stable list so the style effect does not re-apply on every render. */
export const KORTLAG_3D_EXTRUSION_LAYERS = [KORTLAG_BUILDING_EXTRUSION_LAYER_ID] as const;

export const KORTLAG_MAP_DEFAULT_STYLE = "mapbox://styles/mapbox/streets-v12";
